import { useEffect, useState } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Spinner } from 'component-library';

import { useProfileV2 } from '#lib/Profile';
import { useFlagsStatus } from '#lib/hooks/useFlag';
import { I18nReady } from './components/I18nReady';
import { LoadingI18n } from './components/LoadingI8n';
import { initializeI18n } from './InitializeI18n';
import { initializeDayjs } from './initializeDayjs';

type ContentProviderProps = {
  children: React.ReactNode;
  applicationName: string;
  simpleLoader?: boolean;
  allowUnauthenticated?: boolean;
};

const ContentProvider = ({
  children,
  applicationName,

  simpleLoader,
}: ContentProviderProps) => {
  const [i18nInitialized, setI18nInitialized] = useState(false);

  const { basicProfile, error } = useProfileV2();

  const { flagsReady } = useFlagsStatus();

  useEffect(() => {
    const initialize = async () => {
      if (i18nInitialized) return;

      if (!basicProfile) {
        return;
      }

      if (!flagsReady) {
        return;
      }

      const userLang = basicProfile.language;

      await initializeI18n({
        applicationName,
        userLang,
      });

      setI18nInitialized(true);
    };

    void initialize();
  }, [applicationName, i18nInitialized, basicProfile, flagsReady]);

  useEffect(() => {
    if (basicProfile?.language) {
      initializeDayjs(basicProfile.language);
    }
  }, [basicProfile?.language]);

  if (!i18nInitialized) {
    if (simpleLoader) {
      return <Spinner size="xlarge" />;
    }

    return <LoadingI18n error={error} />;
  }

  return <I18nReady>{children}</I18nReady>;
};

export default withAuthenticationRequired(ContentProvider, {
  onRedirecting: () => <LoadingI18n />,
  returnTo: () => {
    return window.location.pathname + window.location.search;
  },
});
